import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0F] text-white flex items-center justify-center p-6">
      <div className="text-center max-w-lg">
        <div className="text-7xl font-bold mb-4">
          <span className="bg-clip-text text-transparent" style={{
            background: "linear-gradient(90deg, #FBD282, #B59143)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}>404</span>
        </div>
        <p className="text-xl text-[#C3C9D3] mb-6">The page you are looking for doesn’t exist.</p>
        <Link
          to="/login"
          className="inline-block px-6 py-3 rounded-lg bg-[#1A1C1F] border border-[#2E2F33] hover:border-[#B59143] hover:shadow-[0_0_12px_rgba(181,145,67,0.25)] transition"
        >
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default NotFound;


